import { readMessageBack } from "../../utils/readMessageBack";
import actionTypes from "../actionTypes";

export interface ComisionItem {
  club: string;
  descripcion: string;
  estatusComision: string;
  idComision: number;
  importe: number;
  montoComision: number;
  porcentaje: number;
  tipocomision: string;
  folioFactura: string;
  fechaAutorizacion: string;
  usuarioAutorizacion: string;
  conceptoResidual: boolean;
}

export interface ComisionesPagadas {
  comisiones: ComisionItem[];
  totalImporte: number;
  totalComision: number;
  cantidadComisionesMembresia: number;
  cantidadComisionesDeportiva: number;
  cantidadOtrasComisiones: number;
}

export interface GetComisionPagadas {
  comisionesPagadas: ComisionesPagadas;
  gettingComisionesPagadas: boolean;
  gettingComisionesPagadasError: any;
}

export interface State extends GetComisionPagadas {}

const initialState: State = {
  comisionesPagadas: null,
  gettingComisionesPagadas: false,
  gettingComisionesPagadasError: null
};

export default function comisionReducer(
  state: State = initialState,
  action: any = {}
): State {
  switch (action.type) {
    case actionTypes.CLEAR_COMISION:
      return {
        ...state,
        comisionesPagadas: null,
        gettingComisionesPagadas: false,
        gettingComisionesPagadasError: null
      };

    case `${actionTypes.GET_COMISION_PAGADAS}_PENDING`:
      return {
        ...state,
        gettingComisionesPagadas: true,
        gettingComisionesPagadasError: null
      };

    case `${actionTypes.GET_COMISION_PAGADAS}_REJECTED`:
      return {
        ...state,
        gettingComisionesPagadas: false,
        gettingComisionesPagadasError: readMessageBack(action)
      };

    case `${actionTypes.GET_COMISION_PAGADAS}_FULFILLED`:
      return {
        ...state,
        comisionesPagadas: action.payload.data,
        gettingComisionesPagadas: false,
        gettingComisionesPagadasError: null
      };

    default:
      return state;
  }
}
